import React from "react";

const Toggle = ({ enabled, onChange, label }) => (
  <div className="flex items-center gap-3">
    <button
      type="button"
      onClick={() => onChange(!enabled)}
      className={`toggle-switch ${enabled ? "active" : ""}`}
      aria-label={label}
    />
    {label && (
      <span className="text-sm text-on-surface-light dark:text-on-surface font-medium">
        {label}
      </span>
    )}
  </div>
);

export default Toggle;
